import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=365883b8&"
import script from "./DataTable.js?vue&type=script&lang=js&"
export * from "./DataTable.js?vue&type=script&lang=js&"
import style0 from "./DataTable.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports